if (typeof DynaCore_FormConfig_Properties == 'undefined') {
    var DynaCore_FormConfig_Properties =
    {
        /**
         * Upraveni nastaveni elementu formulare
         *
         * @param element
         * @param partName
         * @param partId
         * @param subPartName
         * @param subPartId
         */
        edit: function(element, partName, partId, subPartName, subPartId)
        {
            var url = window.location.href.replace('/form-config/', '/form-config/properties');
                url += '?_ch=' + $('#_ch').val();
                url += '&parNam=' + partName;
                url += '&parId=' + partId;

            if (typeof subPartName != 'undefined') {
                url += '&subParNam=' + subPartName;
                url += '&subParId=' + subPartId;
            }

            $.ajax({
                type: 'get',
                url: url,
                dataType: "json",
                beforeSend: function () {
                    $(element).attr('disabled', true).prop('disabled', true);
                },
                complete: function () {
                    $(element).attr('disabled', false).prop('disabled', false);
                },
                success: function (response) {
                    Lemo_Modal.setId('modal-container-formconfig-properties-edit');
                    Lemo_Modal.setTitle('Properties');
                    Lemo_Modal.setContent(response.html);
                    Lemo_Modal.setSize('large');
                    Lemo_Modal.addButton('change', '<i class="fas fa-fw fa-check"></i> ' + translate('Change'), 'btn btn-primary', function() {
                        $.ajax({
                            type: 'post',
                            url: url,
                            data: $('#modal-container-formconfig-properties-edit').find(':input').serialize(),
                            dataType: "json",
                            success: function(response) {
                                $.each(response.messages, function(i, message) {
                                    Lemo_Alert.build(message.type, message.title, message.text);
                                });

                                if (true === response.status) {
                                    Lemo_Alert.addSuccess('Properties have been successfully updated');
                                    Lemo_Modal.close();
                                } else {
                                    $('#dialogBody').html(response.html);
                                }
                            },
                            error: function() {
                                Lemo_Alert.addDanger('An unexpected error occurred');
                            }
                        });
                    });
                    Lemo_Modal.addButton('cancel', '<i class="fas fa-fw fa-times"></i> ' + translate('Cancel'), 'btn btn-secondary', function() {
                        Lemo_Modal.close();
                    });
                    Lemo_Modal.build();

                    DynaCore_Combination.init();
                },
                error: function() {
                    Lemo_Alert.addDanger('An unexpected error occurred');
                }
            });
        },

        editInit: function()
        {
            // Podminka - Typ
            $("#properties").off('change', '.property-value');
            $("#properties").on('change', '.property-value', function () {
                if ('' == this.value) {
                    $(this).parents('.tab-pane').find('.combination-group-container').html('');
                }
            });
        }
    }
}